module.exports = __webpack_public_path__ + "static/media/doclad3.d54f37b3.pdf";